import React, { Component } from 'react';
import "./style.css"
// import Document from "../Document/Document";
import { CardContent, Card, Grid, Grid2, CircularProgress, Typography, Box, Tabs, Tab } from '@mui/material';
import BreadcrumbComp from '../CommonComponents/Breadcrumb/Breadcrumb';
import { getCustomerDetail } from '../../services/customerService';
import { toastAlert } from '../../helpers/toastAlert';
import { withRouter } from 'react-router-dom';
import ProfileCard from '../CommonComponents/ProfileCard';
import ActivityLog from '../CommonComponents/ActivityLog';
import DocumentList from '../CommonComponents/DocumentList';
import { connect } from 'react-redux';
// import Time from "../../../assets/images/Time.png"
// import PaymentsIcon from '@mui/icons-material/Payments';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import CreditScoreRoundedIcon from '@mui/icons-material/CreditScoreRounded';

// import PersonalInformation from '../PersonalInformation/PersonalInformation';
// import PaymentMethodSliderComp from '../PaymentMethodSlider/PaymentMethodSliderComp';

import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import FolderIcon from '@mui/icons-material/Folder';
import Communicationdetail from '../CommonComponents/Communicationdetail';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';

class CustomerDetailComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            editCustomer: false,
            error: [],
            tabValue: 0,

            // Edit customer values
            editModel: false,
            editError: [],
            editName: "",
            editEmail: "",
            editMobile: "",
            editDepartment: "",
        }
    }


    getCustomerData = async () => {
        try {
            console.log('getCustomerData : Id : ', this.props.match.params.id);
            var customerData = await getCustomerDetail({ customerId: this.props.match.params.id }, this.props);

            if (customerData && customerData?.data != null) {
                this.setState({
                    data: customerData.data,
                    loading: false,
                })
            } else {
                // error
                console.log('error customer details : ', customerData, customerData.message);
                let message = customerData && customerData.message !== undefined ? customerData.message : "Problem Fetching Records.";
                this.setState({ loading: false });
            }
        } catch (error) {
            console.log('error catch block', error);
            toastAlert("Please check Internet Connection.", "error");
            this.setState({ loading: false });
        }
    }

    componentDidMount() {
        this.getCustomerData();
    }


    itemArray = () => {
        const { data } = this.state;
        const { location } = this.props;
        let stateData = location?.status?.label;
        return (
            [
                {
                    name: "Customers",
                    active: false,
                    link: "/customers"
                },
                {
                    name: "View Customer",
                    active: true,
                    link: ""
                }
            ]
        )
    }

    render() {
        const { data, loading, tabValue } = this.state;
        const handleChange = (event, newValue) => {
            this.setState({ tabValue: newValue });
        };
        return (
            <div>
                <Grid container>
                    <Grid item lg={12} sm={12} xs={12} md={12}>
                        {/* Breadcrumb-component : start */}
                        <BreadcrumbComp items={this.itemArray()} />
                        {/* Breadcrumb-component : end */}
                    </Grid>

                    {/* <Box sx={{ padding: 3 }}> */}
                    <Grid container spacing={2} sx={{ padding: 3 }}>
                        {/* Profile Section */}
                        <Grid item xs={12} md={5}>
                            <ProfileCard
                                name={data?.name}
                                email={data?.email}
                                mobile={data?.mobile}
                                role={data?.userId?.role}
                                department={data?.officeAddr}
                            />
                        </Grid>

                        {/* Tab Section */}
                        <Grid item xs={12} md={7}>
                            <Box sx={{ width: '100%', typography: 'body1' }}>
                                <Tabs
                                    value={tabValue}
                                    onChange={handleChange}
                                    textColor="inherit"
                                    indicatorColor="secondary"
                                    sx={{
                                        '& .MuiTabs-indicator': {
                                            height: '4px',
                                            backgroundColor: 'var(--thm-color)',
                                            borderRadius: '5px',
                                            transition: '0.3s',
                                        },
                                        '& .MuiTab-root': {
                                            textTransform: 'none',
                                            fontWeight: 'bold',
                                            padding: '12px 24px',
                                            '&:hover': {
                                                color: 'var(--thm-color)',
                                            },
                                        },
                                        '& .Mui-selected': {
                                            color: 'var(--thm-color) !important',
                                        },
                                    }}
                                >
                                    <Tab icon={<FolderIcon />} iconPosition="start" label="Documents" />
                                     <Tab icon={<ForumOutlinedIcon />} iconPosition="start" label="Communication Log" />

                                    {/* <Tab icon={<PersonIcon />} iconPosition="start" label="Profile" /> */}
                                </Tabs>
                            </Box>
                            <Box sx={{ paddingTop: 2 }}>
                                {tabValue === 0 && <DocumentList props={this.props} Id={data?._id} />}
                                {tabValue === 1 && <Communicationdetail/>}
                            </Box>
                        </Grid>
                    </Grid>
                    {/* </Box> */}
                </Grid>
            </div >
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.authReducer,
})

export default withRouter(connect(mapStateToProps)(CustomerDetailComponent))